// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-select[data-v-13a5b567],.custom-select[data-v-13a5b567]:focus{max-width:170px;font-family:Tungsten Bold,sans-serif;background:transparent;box-shadow:none;color:#119dea;border:0;border-bottom:1px solid #119dea;font-size:24px;height:48px;margin:-17px 0 0 5px}", ""]);
// Exports
module.exports = exports;
